module.exports = __webpack_public_path__ + "static/media/home-empty-state-v2.6a8f2038.svg";